<button type="button" [disabled]="loading" class="btn btn-outline-secondary" (click)="exportExcel()" rippleEffect>
    <span *ngIf="loading" class="spinner-border spinner-border-sm"></span>
    <span *ngIf="!loading">Export Excel</span>
</button>